import myAxios from './myAxios'
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from '../spUtils'
import { Design_Upload_Map, deviceNo, SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW, Upload_Building, Upload_Data, Upload_Mesh, URL } from '../../const/infoConst'
import axios from 'axios'
import { exportTimeInterval } from '../timeUtils'
import { get_measureyOrDongle } from '../profileUtils'


//登录
export const reqLogin = (maddr, pwd, platform, deviceNo) => myAxios.post(URL + '/login', { maddr, pwd, platform, deviceNo })
export const sendEmailVerificationCode = (maddr) => myAxios.post(URL + '/sendEmailVerificationCode', { maddr })
export const sendEmailVerificationCodedelet = (maddr, type) => myAxios.post(URL + '/sendEmailVerificationCode', { maddr, type })
export const verifyAuth = (maddr, code, pwd) => myAxios.post(URL + '/verifyAuth', { maddr, code, pwd })
export const deleteuser = (maddr, code, token, deviceNo) => myAxios.post(URL + '/deleteuser', { maddr, code, token, deviceNo })

//获取building列表
export const getBuilding = (maddr, deviceNo, token) => myAxios.post(URL + '/building', { maddr, deviceNo, token })
//创建新Building(或更新)
export const createOrUpdateBuilding = (maddr, token, deviceNo, buildingUUID, buildingName, companyName, city, address, introduction, isSelected) => myAxios.post(URL + '/createBuilding', { maddr, token, deviceNo, buildingUUID, buildingName, companyName, city, address, introduction, isSelected })
//删除Building
export const deleteBuilding = (maddr, deviceNo, token, buildingUUID) => myAxios.post(URL + '/deletemesh', { maddr, deviceNo, token, buildingUUID })

//获取mesh列表
export const getMesh = (maddr, deviceNo, token, buildingUUID) => myAxios.post(URL + '/mesh', { maddr, deviceNo, token, buildingUUID })
//创建新Mesh(或更新)
export const createOrUpdateMesh = (maddr, token, deviceNo, buildingUUID, meshUUID, meshName) => myAxios.post(URL + '/createMesh', { maddr, token, deviceNo, buildingUUID, meshUUID, meshName })
//删除Mesh
export const deleteMesh = (maddr, deviceNo, token, meshUUID) => myAxios.post(URL + '/deletemesh', { maddr, deviceNo, token, meshUUID })


//获取分享列表
export const getQRReceiverList = (maddr, deviceNo, token, buildingUUID, meshUUID) => myAxios.post(URL + '/qrreceiverlist', { maddr, deviceNo, token, buildingUUID, meshUUID })
//删除分享账户
export const deleteShareBuildingMesh = (maddr, deviceNo, token, buildingUUID, meshUUID, receiver) => myAxios.post(URL + '/delsharebuilding', { maddr, deviceNo, token, buildingUUID, meshUUID, receiver })


//上传布点图
export const uploadFileImg = (info) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '')//加载框
    let version = parseInt(SPGet("mesh_version"));
    let filename = "image_" + exportTimeInterval() * 1000; //20230223113453
    var blob = new Blob([info], { type: "image/jpeg" });
    var file = new File([blob], filename + ".jpg", { type: "image/jpeg" });
    let jsonData = JSON.parse(SPGet("jsonData"))
    const formdata = new FormData();
    formdata.append("maddr", SPGet('email'))
    formdata.append("token", SPGet("token"))
    formdata.append("meshUUID", jsonData.meshUUID)
    formdata.append("version", version + '')
    formdata.append("deviceNo", deviceNo);
    formdata.append("file", file)
    meshLog("上传profile version=", version);
    axios({
        url: URL + '/imageUpload',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formdata
    }).then(async (request) => {
        //{"code":0,"msg":{"url":"http://test.hsesmartinc.com/uploads/images/20251229/image_1766995092000_20251229_025813.jpg"}}
        let obj = JSON.stringify(request.data);
        let result = JSON.parse(obj);
        meshLog("wjk 密文" + obj);
        const { code, msg } = result;
        if (code == 0) {
            SPSet("mesh_version", version + 1); //版本号
            PubSub.publish(Design_Upload_Map, msg.url);//布点图
            meshLog("wjk 图片 上传成功: " + msg.url);
        }
        PubSub.publish(SPIN_DIALOG_HIDE, "");
    },
        error => {
            meshLog("wjk error" + JSON.stringify(error.data));
        }
    )
}
//上传profile
export const uploadFileNetworking = (meshUUID, info, upload_type) => {
    if (upload_type != Upload_Data) {
        PubSub.publish(SPIN_DIALOG_SHOW, '')//加载框
    }
    let version = parseInt(SPGet("mesh_version"));
    let filename = meshUUID + "_" + exportTimeInterval() * 1000; //20230223113453
    var blob = new Blob([info], { type: "text/plain;charset=UTF-8;" });
    var file = new File([blob], filename + ".json", { type: "text/plain; charset = UTF-8;" });
    const formdata = new FormData();
    formdata.append("maddr", SPGet('email'))
    formdata.append("token", SPGet("token"))
    formdata.append("meshUUID", meshUUID)
    formdata.append("version", version + '')
    formdata.append("deviceNo", deviceNo);
    formdata.append("macAddr", get_measureyOrDongle());
    formdata.append("file", file)
    meshLog("上传profile version=", version);
    axios({
        url: URL + '/fileUpload',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formdata
    }).then(async (request) => {
        //{"code":0,"msg":{"url":"https://iot.hsesmartinc.com/uploads/files/20251106/12553745994971922384281B8A57BD85_1762418856000_20251106_084737.json"}}
        let obj = JSON.stringify(request.data);
        let result = JSON.parse(obj);
        // meshLog("wjk 密文" + info);
        const { code, msg } = result;
        if (code == 0) {
            SPSet("mesh_version", version + 1); //版本号
            meshLog("wjk profile 上传成功");
            if (upload_type == Upload_Building) {
                PubSub.publish("reloadBuildingData", "");
            } else if (upload_type == Upload_Mesh) {
                PubSub.publish("reloadMeshData", "");
            } else if (upload_type == Upload_Data) {
                //json上传成功
            }
        }
    },
        error => {
            meshLog("wjk error" + JSON.stringify(error.data));
        }
    )

}
//获取应急log数据
export const searchEmergency = (deviceNo, maddr, token, type, mac, group) => myAxios.post(URL + '/manage/searchEmergency', { deviceNo, maddr, token, type, mac, group })
//下载应急log数据
export const downEmergencyLog = (result, maddr, MeshName) => myAxios.post(URL + '/manage/downEmergencyLog', { result, maddr, MeshName })
//获取计量数据
export const searchPower = (deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom) => myAxios.post(URL + '/manage/searchPower', { deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom })
//下载应急log数据
export const downSearchPowerLog = (result, maddr, MeshName, value) => myAxios.post(URL + '/manage/downSearchPowerLog', { result, maddr, MeshName, value })
//获取计量数据
export const searchPower1 = (deviceNo, maddr, token, mac, startDate, endDate, type, meshUUID, zoom) => myAxios.post(URL + '/manage/searchPowerV2', { deviceNo, maddr, token, mac, startDate, endDate, type, meshUUID, zoom })
//获取计量数据
export const searchPower2 = (deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom) => myAxios.post(URL + '/manage/searchPowerV2', { deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom })
//获取计量数据
export const searchPower3 = (deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom, device) => myAxios.post(URL + '/manage/searchPowerV2', { deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom, device })
